/* eslint eqeqeq:"off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { ToastContainer } from "react-toastify";
import { isEmpty } from "lodash";
import { Col, Input, Row } from "antd";
import "./index.css";
import { ProductFilled, UsergroupAddOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { PiStar, PiStarFill } from "react-icons/pi";
import { reportsTab } from "./data";
import { BiNotepad } from "react-icons/bi";
import useMedia from "use-media-antd-query";
// import { BiBarcode } from "react-icons/bi";
// import ReactStars from "react-rating-stars-component";

const Reports = () => {
  const history = useHistory();
  const media = useMedia();

  //Initial state
  const [reportsSelected, setReportsSelected] = useState("all");
  const [renderPage, setRenderPage] = useState(false);

  const [summaryRows, setSummaryRows] = useState([
    {
      label: "Stock Detail Report",
      itemSelected: "",
      mode: "items",
      checked: false,
      path: "/reports/stock-details-report",
      key: "1",
    },
    {
      label: "Sales Report",
      // label: "Sales report filter operations",
      key: "2",
      itemSelected: "",
      mode: "party",
      path: "/reports/sales-report",
      checked: false,
    },
    {
      label: "Sales Return Report",
      key: "3",
      itemSelected: "",
      mode: "party",
      path: "/reports/sales-return-report",
      checked: false,
    },
    {
      label: "Sales Summary Report",
      key: "4",
      itemSelected: "",
      mode: "party",
      path: "/reports/sales-summary-report",
      checked: false,
    },
    {
      label: "Purchase Summary Report",
      key: "5",
      itemSelected: "",
      mode: "party",
      path: "/reports/purchase-summary-report",
      checked: false,
    },
    {
      label: "Profit Loss Report",
      key: "5",
      itemSelected: "",
      mode: "party",
      path: "/reports/profit-loss-report",
      checked: false,
    },
  ]);
  const [partyListRows, setPartyListRows] = useState([
    // {
    //   label: "Party Report By Item",
    //   key: "1",
    //   itemSelected: "",
    //   mode: "party",
    //   path: "",
    //   checked: false,
    // },
    {
      label: "Party Statement (Ledger)",
      key: "1",
      itemSelected: "",
      mode: "party",
      path: "/reports/party-ledger-statement",
      checked: false,
    },
    {
      label: "Party Wise Outstanding",
      key: "2",
      itemSelected: "",
      mode: "party",
      path: "/reports/party-wise-outstanding",
      checked: false,
    },
    {
      label: "Payment In Report",
      key: "3",
      itemSelected: "",
      mode: "party",
      path: "/reports/payment-in-report",
      checked: false,
    },
    {
      label: "Payment out Report",
      key: "4",
      itemSelected: "",
      mode: "party",
      path: "/reports/payment-out-report",
      checked: false,
    },
    {
      label: "Cash In Report",
      key: "5",
      itemSelected: "",
      mode: "party",
      path: "/reports/cash-in-report",
      checked: false,
    },
  ]);

  const [itemListRows, setItemListRows] = useState([
    {
      label: "Item Quantity Report",
      // label: "Item Sales and Purchase Summary",
      itemSelected: "",
      checked: false,
      mode: "items",
      path: "/reports/item-quantity-report",
      key: "1",
    },
    {
      label: "Sales Item quantity Reports",
      itemSelected: "",
      checked: false,
      mode: "items",
      path: "/reports/sales-item-quantity-report",
      key: "2",
    },
    {
      label: "Sales Return Item Reports",
      itemSelected: "",
      checked: false,
      mode: "items",
      path: "/reports/sales-return-items-report",
      key: "3",
    },
    {
      label: "Barcode Items Report",
      key: "4",
      itemSelected: "",
      mode: "barcode",
      path: "/reports/barcode-items-report",
      checked: false,
    },
    {
      label: "Expenses Reports",
      itemSelected: "",
      checked: false,
      mode: "items",
      path: "/reports/expenses-report",
      key: "5",
    },
    // {
    //   label: "Stock Summary",
    //   itemSelected: "",
    //   mode: "items",
    //   checked: false,
    //   path: "",
    //   key: "6",
    // },
  ]);

  //item report change
  const itemListChange = (e, name, index, data) => {
    var itemListArray = itemListRows;
    if (name == "label") {
      e = e.target.checked;
      itemListArray[index]["label"] = data;
      itemListArray[index]["key"] = index + 1;
      itemListArray[index]["itemSelected"] = data;
      itemListArray[index]["checked"] = e;
      setItemListRows(itemListArray);
      setRenderPage(!renderPage);
    }
  };

  //item report change
  const barcodeChange = (e, name, index, data) => {
    var barcodeArray = summaryRows;
    if (name == "label") {
      e = e.target.checked;
      barcodeArray[index]["label"] = data;
      barcodeArray[index]["key"] = index + 1;
      barcodeArray[index]["itemSelected"] = data;
      barcodeArray[index]["checked"] = e;
      setSummaryRows(barcodeArray);
      setRenderPage(!renderPage);
    }
  };

  //party report change

  const partyListChange = (e, name, index, data) => {
    var partyListArray = partyListRows;
    if (name == "label") {
      e = e.target.checked;
      partyListArray[index]["label"] = data;
      partyListArray[index]["key"] = index + 1;
      partyListArray[index]["itemSelected"] = data;
      partyListArray[index]["checked"] = e;
      setPartyListRows(partyListArray);
      setRenderPage(!renderPage);
    }
  };

  const itemSelectedReports =
    itemListRows.length > 0
      ? itemListRows.filter((data) => data.checked == true)
      : [];
  const partySelectedReports =
    partyListRows.length > 0
      ? partyListRows.filter((data) => data.checked == true)
      : [];
  const barcodeSelectedReports =
    summaryRows.length > 0
      ? summaryRows.filter((data) => data.checked == true)
      : [];

  const selectedReports =
    itemSelectedReports.length == 0 &&
    partySelectedReports.length > 0 &&
    barcodeSelectedReports.length > 0
      ? partySelectedReports.concat(barcodeSelectedReports)
      : itemSelectedReports.length > 0 &&
        partySelectedReports.length == 0 &&
        barcodeSelectedReports.length > 0
      ? itemSelectedReports.concat(barcodeSelectedReports)
      : itemSelectedReports.length > 0 &&
        partySelectedReports.length > 0 &&
        barcodeSelectedReports.length == 0
      ? itemSelectedReports.concat(partySelectedReports)
      : itemSelectedReports.length > 0 &&
        partySelectedReports.length == 0 &&
        barcodeSelectedReports.length == 0
      ? itemSelectedReports
      : itemSelectedReports.length == 0 &&
        partySelectedReports.length > 0 &&
        barcodeSelectedReports.length == 0
      ? partySelectedReports
      : itemSelectedReports.length == 0 &&
        partySelectedReports.length == 0 &&
        barcodeSelectedReports.length > 0
      ? barcodeSelectedReports
      : itemSelectedReports.length > 0 &&
        partySelectedReports.length > 0 &&
        barcodeSelectedReports.length > 0
      ? itemSelectedReports
          .concat(partySelectedReports)
          .concat(barcodeSelectedReports)
      : [];

  console.log(selectedReports, "selectedReports");

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      {/* <Layout> */}
      <div className="pl-5">
        <MetaTags>
          <title>Reports | Mbook</title>
        </MetaTags>
      </div>
      {/* <Row className="bg-[#ffffff]"> */}
      <Row className="bg-[#ffffff]">
        <Col span={24} className="border pb-2 border-b-1 border-x-0 border-t-0">
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
            <div className="flex">
              <h1
                className="text-[18px] ml-2 mt-1 font-semibold"
                style={{
                  fontFamily: "Poppins",
                }}
              >
                Reports
              </h1>
            </div>
            {/* <div className="flex">
              <div className="flex text-[12px] border bg-[#ffffff] text-[#000000] rounded-md ml-3 pl-6 pr-6 p-1 cursor-pointer">
                <PiUserSoundFill className="mt-1 mr-2" /> Share Suggestion
              </div>
            </div> */}
          </div>
        </Col>
      </Row>
      <Row
        className={
          // (windowDimensions.height >= 700 && windowDimensions.height <= 767) ||
          // (windowDimensions.height > 767 && windowDimensions.height < 830)
          //   ? "bg-[#ffffff] dashboard-main-card-large-device"
          windowDimensions.height >= 1000
            ? "bg-[#ffffff] reports-main-dashboard-card-extra-large-device"
            : "bg-[#ffffff] reports-main-dashboard-main-card"
        }
      >
        <Col
          md={24}
          lg={24}
          xl={24}
          xxl={24}
          sm={24}
          xs={24}
          className="pb-2 mt-4"
        >
          <Row className="pl-[25px] pr-[25px]">
            <Col>
              <h1
                className="text-[14px] text-[#687e96] font-semibold mt-2"
                style={{
                  fontFamily: "Poppins",
                }}
              >
                Filter By
              </h1>
            </Col>
            <Col
              md={20}
              lg={20}
              sm={24}
              xs={24}
              xl={20}
              xxl={20}
              className="ml-3"
            >
              <Row
                className={
                  media == "sm" || media == "xs"
                    ? "flex flex-row mt-2"
                    : "flex flex-row"
                }
              >
                {reportsTab.map((data, index) => {
                  return (
                    <Col
                      md={4}
                      lg={4}
                      xl={4}
                      xxl={4}
                      sm={24}
                      xs={24}
                      key={index}
                      className={
                        media == "sm" || media == "xs"
                          ? "mb-3 pr-4 cursor-pointer"
                          : "pr-4 cursor-pointer"
                      }
                    >
                      <div
                        className="p-2 text-center"
                        style={{
                          border:
                            reportsSelected === data.mode
                              ? "1px solid black"
                              : "1px solid lightgray",
                          borderRadius: "20px",
                          backgroundColor:
                            reportsSelected === data.mode ? "lightgray" : "",
                          // backgroundColor:
                          //   reportsSelected === data.mode ? "lightgray" : "",
                        }}
                        onClick={() => {
                          setReportsSelected(data.mode);
                        }}
                      >
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                        >
                          {data.label}
                        </h1>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
          {reportsSelected === "items" ? (
            <>
              {media == "sm" || media == "xs" ? (
                <Row className="w-[100%] mt-3">
                  <Col md={8} lg={8} xl={8} xxl={8} sm={24} xs={24}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className={
                          "border border-x-1 h-[200px] pl-5 pr-5 pt-3 pb-3"
                        }
                      >
                        {selectedReports && selectedReports.length > 0
                          ? selectedReports.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold"
                                  >
                                    <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>
                  {/* reports data */}
                  <Col
                    md={8}
                    lg={8}
                    xl={8} 
                    xxl={8}
                    sm={24}
                    xs={24}
                    // className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                  >
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Items
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className="border h-[200px] border-x-1 pl-5 pr-5 pt-3 pb-3"
                      >
                        {itemListRows && itemListRows.length > 0
                          ? itemListRows.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  {/* {reportsName == data.label ? ( */}
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                  >
                                    <Input
                                      type="checkbox"
                                      className="star"
                                      name={"label"}
                                      value={data.label}
                                      onChange={(e) =>
                                        itemListChange(
                                          e,
                                          "label",
                                          index,
                                          data.label
                                        )
                                      }
                                    />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>

                  {/* {!isEmpty(reportsSelected) && reportsSelected === "items"} */}
                </Row>
              ) : (
                <Row className="w-[100%] mt-3">
                  <Col md={8} lg={8} xl={8} sm={24} xs={24} xxl={8}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className={
                          "border border-x-1 h-[200px] pl-5 pr-5 pt-3 pb-3"
                        }
                      >
                        {selectedReports && selectedReports.length > 0
                          ? selectedReports.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold"
                                  >
                                    <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>
                  {/* reports data */}

                  <Col
                    md={8}
                    lg={8}
                    sm={24}
                    xs={24}
                    xl={8}
                    xxl={8}
                    // className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                  >
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Items
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className="border h-[200px] border-x-1 pl-5 pr-5 pt-3 pb-3"
                      >
                        {itemListRows && itemListRows.length > 0
                          ? itemListRows.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  {/* {reportsName == data.label ? ( */}
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                  >
                                    <Input
                                      type="checkbox"
                                      className="star"
                                      name={"label"}
                                      value={data.label}
                                      onChange={(e) =>
                                        itemListChange(
                                          e,
                                          "label",
                                          index,
                                          data.label
                                        )
                                      }
                                    />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>

                  {/* {!isEmpty(reportsSelected) && reportsSelected === "items"} */}
                </Row>
              )}
            </>
          ) : reportsSelected === "party" ? (
            <>
              {media == "sm" || media == "xs" ? (
                <Row className="w-[100%] mt-3">
                  <Col md={8} lg={8} xl={8} xxl={8} sm={24} xs={24}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className={
                          "border border-x-1 h-[200px] pl-5 pr-5 pt-3 pb-3"
                        }
                      >
                        {selectedReports && selectedReports.length > 0
                          ? selectedReports.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold"
                                  >
                                    <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>
                  {/* reports data */}

                  <Col md={8} lg={8} xl={8} sm={24} xs={24} xxl={8}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Party
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className="border h-[200px] border-x-1 pl-5 pr-5 pt-3 pb-3"
                      >
                        {partyListRows && partyListRows.length > 0
                          ? partyListRows.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  {/* {reportsName == data.label ? ( */}
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                  >
                                    <Input
                                      type="checkbox"
                                      className="star"
                                      name={"label"}
                                      value={data.label}
                                      onChange={(e) =>
                                        partyListChange(
                                          e,
                                          "label",
                                          index,
                                          data.label
                                        )
                                      }
                                    />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>

                  {/* {!isEmpty(reportsSelected) && reportsSelected === "items"} */}
                </Row>
              ) : (
                <Row className="w-[100%] mt-3">
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className={
                          "border border-x-1 h-[200px] pl-5 pr-5 pt-3 pb-3"
                        }
                      >
                        {selectedReports && selectedReports.length > 0
                          ? selectedReports.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold"
                                  >
                                    <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>
                  {/* reports data */}

                  <Col
                    md={8}
                    lg={8}
                    // className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                  >
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Party
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className="border h-[200px] border-x-1 pl-5 pr-5 pt-3 pb-3"
                      >
                        {partyListRows && partyListRows.length > 0
                          ? partyListRows.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  {/* {reportsName == data.label ? ( */}
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                  >
                                    <Input
                                      type="checkbox"
                                      className="star"
                                      name={"label"}
                                      value={data.label}
                                      onChange={(e) =>
                                        partyListChange(
                                          e,
                                          "label",
                                          index,
                                          data.label
                                        )
                                      }
                                    />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>

                  {/* {!isEmpty(reportsSelected) && reportsSelected === "items"} */}
                </Row>
              )}
            </>
          ) : reportsSelected === "summary" ? (
            <>
              {media == "sm" || media == "xs" ? (
                <Row className="w-[100%] mt-3">
                  <Col md={8} lg={8} xl={8} xxl={8} sm={24} xs={24}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className={
                          "border border-x-1 h-[230px] pl-5 pr-5 pt-3 pb-3"
                        }
                      >
                        {selectedReports && selectedReports.length > 0
                          ? selectedReports.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold"
                                  >
                                    <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    md={8}
                    lg={8}
                    sm={24}
                    xs={24}
                    // className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                  >
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Summary
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className="border h-[230px] border-x-1 pl-5 pr-5 pt-3 pb-3"
                      >
                        {summaryRows && summaryRows.length > 0
                          ? summaryRows.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  {/* {reportsName == data.label ? ( */}
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                  >
                                    <Input
                                      type="checkbox"
                                      className="star"
                                      name={"label"}
                                      value={data.label}
                                      onChange={(e) =>
                                        partyListChange(
                                          e,
                                          "label",
                                          index,
                                          data.label
                                        )
                                      }
                                    />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row className="w-[100%] mt-3">
                  <Col md={8} lg={8} xl={8} xxl={8}>
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className={
                          "border border-x-1 h-[230px] pl-5 pr-5 pt-3 pb-3"
                        }
                      >
                        {selectedReports && selectedReports.length > 0
                          ? selectedReports.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold"
                                  >
                                    <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>
                  {/* reports data */}

                  <Col
                    md={8}
                    lg={8}
                    // className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                  >
                    <Row className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3">
                      <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Summary
                        </h1>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        sm={24}
                        xs={24}
                        className="border h-[230px] border-x-1 pl-5 pr-5 pt-3 pb-3"
                      >
                        {summaryRows && summaryRows.length > 0
                          ? summaryRows.map((data, index) => {
                              return (
                                <Row
                                  key={index}
                                  className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                  // onClick={() => {
                                  //   if (!isEmpty(data.path)) {
                                  //     history.push(data.path);
                                  //   }
                                  // }}
                                >
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      if (!isEmpty(data.path)) {
                                        history.push(data.path);
                                      }
                                    }}
                                  >
                                    {data.label}
                                  </h1>
                                  {/* {reportsName == data.label ? ( */}
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                  >
                                    <Input
                                      type="checkbox"
                                      className="star"
                                      name={"label"}
                                      value={data.label}
                                      onChange={(e) =>
                                        partyListChange(
                                          e,
                                          "label",
                                          index,
                                          data.label
                                        )
                                      }
                                    />
                                  </p>
                                </Row>
                              );
                            })
                          : ""}
                      </Col>
                    </Row>
                  </Col>

                  {/* {!isEmpty(reportsSelected) && reportsSelected === "items"} */}
                </Row>
              )}
            </>
          ) : (
            <>
              {" "}
              {media == "sm" || media == "xs" ? (
                <>
                  {" "}
                  <Row className="w-[100%] mt-3">
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Row>
                    </Col>
                    {/* reports data */}
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      {selectedReports && selectedReports.length > 0
                        ? selectedReports.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                // onClick={() => {
                                //   if (!isEmpty(data.path)) {
                                //     history.push(data.path);
                                //   }
                                // }}
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold"
                                >
                                  <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                </p>
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Items
                        </h1>
                      </Row>
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="border border-x-1 pl-5 pr-5 pt-3 pb-3"
                    >
                      {itemListRows && itemListRows.length > 0
                        ? itemListRows.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                // onClick={() => {
                                //   if (!isEmpty(data.path)) {
                                //     history.push(data.path);
                                //   }
                                // }}
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                {/* {reportsName == data.label ? ( */}
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                >
                                  <Input
                                    type="checkbox"
                                    className="star"
                                    name={"label"}
                                    value={data.label}
                                    onChange={(e) =>
                                      itemListChange(
                                        e,
                                        "label",
                                        index,
                                        data.label
                                      )
                                    }
                                  />
                                </p>
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          {" "}
                          <BiNotepad className="text-[20px] mr-2" />
                          Summary
                        </h1>
                      </Row>
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      {summaryRows && summaryRows.length > 0
                        ? summaryRows.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                {/* {reportsName == data.label ? ( */}
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                >
                                  <Input
                                    type="checkbox"
                                    className="star"
                                    name={"label"}
                                    value={data.label}
                                    onChange={(e) =>
                                      barcodeChange(
                                        e,
                                        "label",
                                        index,
                                        data.label
                                      )
                                    }
                                  />
                                </p>
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                  </Row>
                  <Row className="w-[100%] mb-3">
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="bg-gray-50 border border-r-1 border-l-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <UsergroupAddOutlined className="text-[20px] mr-2" />
                          Party
                        </h1>
                      </Row>
                    </Col>
                    {/* reports data */}
                    <Col
                      md={8}
                      lg={8}
                      sm={24}
                      xs={24}
                      className="border border-x-1 pl-5 pr-5 pt-3 pb-3"
                    >
                      {partyListRows && partyListRows.length > 0
                        ? partyListRows.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                {/* {reportsName == data.label ? ( */}
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                >
                                  <Input
                                    type="checkbox"
                                    className="star"
                                    name={"label"}
                                    value={data.label}
                                    onChange={(e) =>
                                      partyListChange(
                                        e,
                                        "label",
                                        index,
                                        data.label
                                      )
                                    }
                                  />
                                </p>
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {" "}
                  <Row className="w-[100%] mt-3">
                    <Col
                      md={8}
                      lg={8}
                      className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <PiStar className="text-[20px] mr-2" />
                          Favourite
                        </h1>
                      </Row>
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      className="bg-gray-50 border border-x-1 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <ProductFilled className="text-[20px] mr-2" />
                          Items
                        </h1>
                      </Row>
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          {" "}
                          <BiNotepad className="text-[20px] mr-2" />
                          Summary
                        </h1>
                      </Row>
                    </Col>
                    {/* reports data */}
                    <Col
                      md={8}
                      lg={8}
                      className="border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      {selectedReports && selectedReports.length > 0
                        ? selectedReports.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                // onClick={() => {
                                //   if (!isEmpty(data.path)) {
                                //     history.push(data.path);
                                //   }
                                // }}
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold"
                                >
                                  <PiStarFill className="text-[20px] text-[#e5e516] mr-2" />
                                </p>
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                    {/* {!isEmpty(reportsSelected) && reportsSelected === "items"} */}
                    <Col
                      md={8}
                      lg={8}
                      className="border border-x-1 pl-5 pr-5 pt-3 pb-3"
                    >
                      {itemListRows && itemListRows.length > 0
                        ? itemListRows.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                // onClick={() => {
                                //   if (!isEmpty(data.path)) {
                                //     history.push(data.path);
                                //   }
                                // }}
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                {/* {reportsName == data.label ? ( */}
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                >
                                  <Input
                                    type="checkbox"
                                    className="star"
                                    name={"label"}
                                    value={data.label}
                                    onChange={(e) =>
                                      itemListChange(
                                        e,
                                        "label",
                                        index,
                                        data.label
                                      )
                                    }
                                  />
                                  {/* <ReactStars
                        count={1}
                        onChange={(e) =>
                          itemListChange(e, index, data.label)
                        }
                        size={20}
                        value={data.label}
                        isHalf={false}
                        emptyIcon={<PiStar className="text-[18px] mr-2" />}
                        fullIcon={
                          <PiStarFill className="text-[18px] text-[yellow] mr-2" />
                        }
                        activeColor="#ffd700"
                      /> */}
                                </p>
                                {/* ) : (
                      ""
                    )} */}
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      className="border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      {summaryRows && summaryRows.length > 0
                        ? summaryRows.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                // onClick={() => {
                                //   if (!isEmpty(data.path)) {
                                //     history.push(data.path);
                                //   }
                                // }}
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                {/* {reportsName == data.label ? ( */}
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                >
                                  <Input
                                    type="checkbox"
                                    className="star"
                                    name={"label"}
                                    value={data.label}
                                    onChange={(e) =>
                                      barcodeChange(
                                        e,
                                        "label",
                                        index,
                                        data.label
                                      )
                                    }
                                  />
                                </p>
                                {/* <p
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="flex text-[14px] text-[#687e96] font-semibold"
                    >
                      <PiStar className="text-[20px] mr-2" />
                    </p> */}
                                {/* ) : (
                  ""
                )} */}
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                  </Row>
                  <Row className="w-[100%] mb-3">
                    <Col
                      md={8}
                      lg={8}
                      className="bg-gray-50 border border-r-1 border-l-0 pl-5 pr-5 pt-3 pb-3"
                    >
                      <Row>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex text-[14px] text-[#687e96] font-semibold"
                        >
                          <UsergroupAddOutlined className="text-[20px] mr-2" />
                          Party
                        </h1>
                      </Row>
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      className="bg-gray-50 border border-r-1 border-l-0 pl-5 pr-5 pt-3 pb-3"
                    ></Col>
                    <Col
                      md={8}
                      lg={8}
                      className="bg-gray-50 border border-x-0 pl-5 pr-5 pt-3 pb-3"
                    ></Col>

                    {/* reports data */}
                    <Col
                      md={8}
                      lg={8}
                      className="border border-x-1 pl-5 pr-5 pt-3 pb-3"
                    >
                      {partyListRows && partyListRows.length > 0
                        ? partyListRows.map((data, index) => {
                            return (
                              <Row
                                key={index}
                                className="cursor-pointer flex justify-between p-2 hover hover:bg-[lightgray] hover:p-2 rounded-md"
                                // onClick={() => {
                                //   if (!isEmpty(data.path)) {
                                //     history.push(data.path);
                                //   }
                                // }}
                              >
                                <h1
                                  style={{
                                    fontFamily: "Poppins",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    if (!isEmpty(data.path)) {
                                      history.push(data.path);
                                    }
                                  }}
                                >
                                  {data.label}
                                </h1>
                                {/* {reportsName == data.label ? ( */}
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                  className="flex text-[14px] text-[#687e96] font-semibold mt-[-8px]"
                                >
                                  <Input
                                    type="checkbox"
                                    className="star"
                                    name={"label"}
                                    value={data.label}
                                    onChange={(e) =>
                                      partyListChange(
                                        e,
                                        "label",
                                        index,
                                        data.label
                                      )
                                    }
                                  />
                                </p>
                                {/* <p
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="flex text-[14px] text-[#687e96] font-semibold"
                    >
                      <PiStar className="text-[20px] mr-2" />
                    </p> */}
                                {/* ) : (
                      ""
                    )} */}
                              </Row>
                            );
                          })
                        : ""}
                    </Col>
                    <Col
                      md={8}
                      lg={8}
                      className="border border-r-1 border-l-0 pl-5 pr-5 pt-3 pb-3"
                    ></Col>
                    <Col
                      md={8}
                      lg={8}
                      className="border border-r-1 border-l-0 pl-5 pr-5 pt-3 pb-3"
                    ></Col>
                  </Row>
                </>
              )}
            </>
          )}
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

export default Reports;
